/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Directive, effect, inject, input } from '@angular/core';
import { Telework } from '../telework';
import { Dayjs } from 'dayjs';
import { TeleworkService } from '../telework.service';
import { DayNotWorkService } from '../day-not-work.service';
import { CommonUtils } from '@infodata-group/inf-commons';

@Directive({
  standalone: true,
  selector: '[inflDayRow]',
  exportAs: 'dayRow',
})
export class DayRowDirective {
  public resource = input<string>();
  public date = input<Dayjs>(null);
  public teleworks = input<Telework[]>([]);

  public isTeleworked = false;
  public isOff = false;
  public isHovered = false;

  private readonly teleworkService = inject(TeleworkService);
  private readonly dayNotWorkService = inject(DayNotWorkService);

  constructor() {
    effect(() => {
      this.isOff = !this.dayNotWorkService.isDayWork(this.date().toDate());
      if (this.teleworks() && this.teleworks().length > 0) {
        this.isTeleworked = !!this.teleworks().find((t) => {
          return (
            t.resourceId === this.resource() &&
            t.date === this.date().format('DD/MM/YYYY')
          );
        });
      }
    });
  }

  public get backgroundColor(): string {
    if (this.isHovered) {
      return '#FFF2DA';
    }
    if (this.isOff) {
      return this.dayNotWorkService.dayNotWorkColor;
    }
    if (this.isTeleworked) {
      return this.teleworkService.teleworkColor;
    }
    return CommonUtils.color('white');
  }
}
